export default __webpack_public_path__ + "images/b655841f55b17a799dae7a5750413280.png";